export default {
  "about": "Acerca de",
  "about_title": "Sobre nosotros",
  "access_secret": "Secreto de acceso",
  "access_token": "Token de acceso",
  "accessibility_animations": "Animaciones",
  "accessibility_contrast": "Contraste",
  "accessibility_font_size": "Tamaño de Fuente",
  "accessibility_title": "Accesibilidad",
  "actions": "Acciones",
  "active": "Activo",
  "active_ads": "Anuncios Activos",
  "active_campaigns": "Campañas Activas",
  "ad_code_placeholder": "<script>...</script> o código de ranura de AdSense",
  "ad_format": "Formato de Anuncio",
  "ad_formats": "Formatos de anuncios",
  "ad_management": "Gestion de anuncios",
  "ad_position_settings": "Configuración de Posición de Anuncios",
  "ad_price_list": "Lista de Precios de Anuncios",
  "ad_pricing_formats_campaigns": "Precios, formatos, campañas y seguimiento",
  "add": "Agregar",
  "add_api_keys": "Agregar claves API en la pestaña Configurar",
  "address": "Dirección",
  "admin": "Admin",
  "adminPanel": "Panel de Administración",
  "admin_ab_testing_title": "Pruebas A/B",
  "admin_accent": "Acento",
  "admin_accent_color": "Color de acento",
  "admin_action": "Acción",
  "admin_activate": "Activar",
  "admin_active_feeds": "Fuentes activas",
  "admin_active_label": "ACTIVO",
  "admin_active_now": "Activo ahora",
  "admin_active_subscribers": "Suscriptores activos",
  "admin_ad_performance": "Rendimiento de anuncios",
  "admin_add_feed": "Agregar fuente",
  "admin_add_tag": "Agregar Etiqueta",
  "admin_admins": "Administradores",
  "admin_advertisements": "Anuncios",
  "admin_advertiser_email": "Email del anunciante",
  "admin_advertiser_name": "Nombre del anunciante",
  "admin_affiliate_links": "Enlaces de Afiliados",
  "admin_ai_content_title": "Procesamiento de contenido AI",
  "admin_ai_prompt_settings": "Configuraciones de modelos y prompts AI",
  "admin_analytics_title": "Analíticas",
  "admin_api_latency": "Latencia de API",
  "admin_api_server": "Servidor API",
  "admin_article_actions": "Acciones",
  "admin_article_category": "Categoría",
  "admin_article_published": "Publicado",
  "admin_article_selector": "Selector de artículo (CSS, por ejemplo, article.news)",
  "admin_article_views": "Vistas",
  "admin_articles_count": "Artículos",
  "admin_articles_title": "Artículos",
  "admin_author_change_failed": "Error en el cambio de autor.",
  "admin_authors_title": "Autores",
  "admin_auto": "AUTO",
  "admin_auto_save_draft": "Guardar automáticamente como borrador",
  "admin_avg_seo_score": "Puntuación media de SEO",
  "admin_bio": "Biografía",
  "admin_blog_manage": "Gestionar entradas de blog con editor de contenido enriquecido",
  "admin_blog_title": "Blog",
  "admin_brand_theme": "Marca & Tema",
  "admin_branding_desc": "Personalizar apariencia del sitio (Solo Admin del Sistema)",
  "admin_branding_title": "Módulo de Rebranding",
  "admin_breaking_ticker": "Ticker de Últimas Noticias",
  "admin_browser": "Navegador",
  "admin_browsers": "Navegadores",
  "admin_bug_reports": "Informes de Errores",
  "admin_bulk_delete_failed": "Error en la eliminación masiva.",
  "admin_bulk_operations": "Operaciones Masivas",
  "admin_categories_grid": "Cuadrícula de Categorías",
  "admin_choose_gallery": "Elegir de la galería",
  "admin_churn_prediction": "Predicción de Pérdida de Clientes",
  "admin_classic_portal": "Portal de Noticias Clásico",
  "admin_classifieds": "Clasificados",
  "admin_clear_log": "Borrar registro",
  "admin_click_button": "Hacer clic en el botón",
  "admin_collection_stats": "Estadísticas de colección",
  "admin_color_scheme": "Esquema de colores",
  "admin_columnist": "Columnista",
  "admin_comments": "Comentarios",
  "admin_competitor_monitoring": "Monitoreo de Competencia",
  "admin_confirm_action": "¿Estás seguro?",
  "admin_content_calendar_title": "Calendario de Contenidos",
  "admin_content_filter": "Términos de filtro de contenido",
  "admin_content_stats": "Estadísticas de contenido",
  "admin_contributor": "Colaborador",
  "admin_coordinates": "Coordenadas",
  "admin_copy_ip": "Copiar dirección IP",
  "admin_copy_text": "Copiar",
  "admin_core_services": "Servicios principales",
  "admin_countries": "Países",
  "admin_cpc": "CPC (EUR)",
  "admin_crawl_now": "Rastrear ahora",
  "admin_create_author": "Crear Autor",
  "admin_create_manage_promo": "Crear y gestionar códigos promocionales",
  "admin_create_voucher": "Crear Cupón",
  "admin_custom_meta": "Meta personalizado",
  "admin_dashboard_title": "Panel",
  "admin_database": "Base de Datos",
  "admin_db_backup": "Copia de Seguridad de la Base de Datos",
  "admin_db_latency": "Latencia de DB",
  "admin_db_name": "Nombre de la base de datos",
  "admin_db_size": "Tamaño de DB",
  "admin_default": "PREDET.",
  "admin_default_language": "Idioma por defecto",
  "admin_device": "Dispositivo",
  "admin_devices": "Dispositivos",
  "admin_discount": "Descuento",
  "admin_disk_usage": "Uso de disco",
  "admin_docs_api_ref": "Referencia API",
  "admin_docs_download_pdf": "Descargar PDF",
  "admin_docs_faq": "FAQ",
  "admin_docs_getting_started": "Comenzando",
  "admin_docs_implemented": "Implementado",
  "admin_docs_no_pages": "Aún no hay páginas de documentación",
  "admin_docs_order": "Ordenar",
  "admin_docs_title": "Documentación",
  "admin_doktor_earnings": "Ganancias de Doktor",
  "admin_draft_articles": "Artículos en borrador",
  "admin_dynamic_pricing": "Precios Dinámicos",
  "admin_edit_in_cms": "Editar en CMS",
  "admin_editor_role": "Editor",
  "admin_export_csv": "Exportar CSV",
  "admin_favicon": "Favicon",
  "admin_feed_crawler": "Rastreador de Fuentes",
  "admin_feed_name": "Nombre de la fuente",
  "admin_feed_url": "URL de la fuente",
  "admin_feeds_title": "Fuentes RSS",
  "admin_file": "Archivo",
  "admin_fixed_amount": "Cantidad Fija",
  "admin_frozen": "Congelado",
  "admin_full_name": "Nombre Completo",
  "admin_general": "General",
  "admin_google_search_console": "Google Search Console",
  "admin_grade": "Calificación",
  "admin_health_title": "Chequeo de salud",
  "admin_high_leads": "Leads de Alto Valor",
  "admin_import_title": "Plataforma de Importación Croatia Times",
  "admin_index_now": "IndexNow",
  "admin_integrations": "Integraciones",
  "admin_job_postings": "Ofertas de Trabajo",
  "admin_joined": "Unido",
  "admin_keywords": "Palabras clave",
  "admin_landing_title": "Páginas de aterrizaje",
  "admin_last_submissions": "Últimas presentaciones",
  "admin_live_analytics": "Analíticas en Vivo",
  "admin_live_analytics_title": "Analíticas en vivo",
  "admin_llm_model": "Modelo LLM",
  "admin_manage_feeds": "Gestionar Fuentes",
  "admin_mass_management": "Gestión masiva de artículos",
  "admin_max_articles": "Máx. artículos",
  "admin_media_storage": "Almacenamiento de medios",
  "admin_memory": "Memoria",
  "admin_menu_manager": "Administrador de Menú",
  "admin_meta_description": "Descripción meta",
  "admin_monetization_title": "Panel de monetización",
  "admin_mysql_db": "Base de datos MySQL",
  "admin_mysql_host": "MySQL Host",
  "admin_nav_ab_testing": "Pruebas A/B",
  "admin_nav_ads": "Gestión de Anuncios",
  "admin_nav_ads_report": "Informe de Anuncios",
  "admin_nav_adsense": "Configuración de AdSense",
  "admin_nav_advanced_analytics": "Análisis Avanzados",
  "admin_nav_affiliates": "Enlaces Afiliados",
  "admin_nav_ai_content": "Procesamiento de Contenido AI",
  "admin_nav_amp": "AMP y Google Discover",
  "admin_nav_analytics": "Análisis",
  "admin_nav_analytics_ai": "Análisis y AI",
  "admin_nav_articles": "Artículos",
  "admin_nav_audit_log": "Registro de Auditoría",
  "admin_nav_authors": "Autores",
  "admin_nav_blog": "Blog",
  "admin_nav_branding": "Rebranding",
  "admin_nav_breaking_news": "Noticias de Última Hora / Flash",
  "admin_nav_bulk_operations": "Operaciones en Masa",
  "admin_nav_categories": "Categorías",
  "admin_nav_chat_sessions": "Sesiones de Chat",
  "admin_nav_churn_prediction": "Predicción de Abandono",
  "admin_nav_classifieds": "Clasificados",
  "admin_nav_comments": "Comentarios",
  "admin_nav_competitor_monitoring": "Monitoreo de Competencia",
  "admin_nav_content": "Contenido",
  "admin_nav_content_calendar": "Calendario de Contenido",
  "admin_nav_county_map": "Mapa del Condado",
  "admin_nav_crypto": "Widget de Crypto",
  "admin_nav_dashboard": "Tablero",
  "admin_nav_db_backup": "Base de Datos",
  "admin_nav_docs": "Documentación",
  "admin_nav_doktor_earnings": "Ingresos Doktor",
  "admin_nav_duplicate_detection": "Detección de Duplicados",
  "admin_nav_editorial": "Editorial",
  "admin_nav_editorial_workflow": "Flujo de Trabajo Editorial",
  "admin_nav_email_campaigns": "Campañas de Correo Electrónico",
  "admin_nav_feeds": "RSS Feeds",
  "admin_nav_finance": "Finanzas",
  "admin_nav_health": "Salud del Sistema",
  "admin_nav_heatmaps": "Mapa de Calor de Lectura",
  "admin_nav_import": "Importar",
  "admin_nav_invoices": "Facturas",
  "admin_nav_job_ads": "Anuncios de Trabajo",
  "admin_nav_landing_pages": "Páginas de Aterrizaje",
  "admin_nav_live_analytics": "Análisis en Vivo",
  "admin_nav_management": "Gestión",
  "admin_nav_marketing": "Marketing",
  "admin_nav_media": "Medios",
  "admin_nav_menu_manager": "Gestor de Menús",
  "admin_nav_micropayments": "Micropagos",
  "admin_nav_monetization": "Monetización",
  "admin_nav_newsletter": "Boletín",
  "admin_nav_newsletter_digest": "Resumen del Boletín",
  "admin_nav_pages": "Páginas",
  "admin_nav_payments": "Pagos",
  "admin_nav_performance_forecast": "Pronóstico de Rendimiento",
  "admin_nav_photo_verification": "Verificación de Fotos",
  "admin_nav_portal_toggle": "Gestión del Portal",
  "admin_nav_portals": "Portales",
  "admin_nav_pricing": "Precios",
  "admin_nav_promo_codes": "Códigos Promocionales",
  "admin_nav_push_notifications": "Notificaciones Push",
  "admin_nav_quizzes": "Cuestionarios",
  "admin_nav_recommendations": "Recomendaciones de Contenido",
  "admin_nav_reports": "Informes de Contenido",
  "admin_nav_sanitization": "Saneamiento de Contenido",
  "admin_nav_scheduler": "Programador de Contenido",
  "admin_nav_security": "Seguridad",
  "admin_nav_seo_dashboard": "Panel SEO",
  "admin_nav_seo_distribution": "SEO y Distribución",
  "admin_nav_series": "Series de Artículos",
  "admin_nav_settings": "Configuración",
  "admin_nav_social": "Redes Sociales",
  "admin_nav_social_scheduler": "Programador Social",
  "admin_nav_sponsored": "Patrocinado",
  "admin_nav_sponsored_marketplace": "Mercado de Patrocinadores",
  "admin_nav_subscriptions": "Suscripciones",
  "admin_nav_surveys": "Encuestas",
  "admin_nav_syndication": "API de Sindicación",
  "admin_nav_system": "Sistema",
  "admin_nav_tips": "Propinas / Donaciones",
  "admin_nav_translations": "Traducciones",
  "admin_nav_ugc_review": "Contenido Ciudadano",
  "admin_nav_users": "Usuarios",
  "admin_nav_users_subscriptions": "Usuarios y Suscripciones",
  "admin_nav_versioning": "Historial de Versiones",
  "admin_nav_vibeposao": "Portal Times Posao",
  "admin_nav_vouchers": "Vales / Descuentos",
  "admin_nav_widgets": "Widgets / Catálogos",
  "admin_new_author_name": "Nuevo nombre del autor...",
  "admin_new_post": "Nueva Entrada",
  "admin_no_data": "No hay datos disponibles",
  "admin_no_icon": "Sin icono",
  "admin_no_logo": "Sin logo",
  "admin_no_pending_reports": "No hay informes pendientes",
  "admin_no_published_articles": "No se encontraron artículos publicados",
  "admin_password_field": "Contraseña",
  "admin_performance_forecast": "Previsión de Rendimiento",
  "admin_photo_verification": "Verificación de Fotos",
  "admin_plan": "Plan",
  "admin_platform_audit": "Auditoría de Plataforma",
  "admin_portal_toggle": "Gestión del Portal",
  "admin_premium_users": "Usuarios Premium",
  "admin_primary": "Primario",
  "admin_published_articles": "Artículos publicados",
  "admin_published_today": "Publicado Hoy",
  "admin_quick_actions": "Acciones Rápidas",
  "admin_recent_articles": "Artículos Recientes",
  "admin_role_change_failed": "Error al actualizar el rol.",
  "admin_search_placeholder": "Buscar en administración...",
  "admin_secondary": "Secundario",
  "admin_seo_desc": "Optimización de contenido, gestión de GSC y sitemaps",
  "admin_seo_title": "Panel de SEO",
  "admin_service_requests": "Solicitudes de Servicio",
  "admin_set_category": "Establecer Categoría",
  "admin_set_featured": "Establecer como Destacado",
  "admin_settings_saved": "Configuraciones guardadas",
  "admin_settings_title": "Configuraciones",
  "admin_short_desc": "Descripción breve",
  "admin_site_identity": "Identidad del sitio",
  "admin_site_logo": "Logo del sitio",
  "admin_site_settings": "Configuración del Sitio",
  "admin_sponsored_marketplace": "Mercado Patrocinado",
  "admin_sponsored_title": "Artículos patrocinados",
  "admin_surveys_title": "Encuestas",
  "admin_system_status": "Estado del Sistema",
  "admin_table_header_actions": "Acciones",
  "admin_table_header_date": "Fecha",
  "admin_table_header_email": "Correo Electrónico",
  "admin_table_header_name": "Nombre",
  "admin_table_header_status": "Estado",
  "admin_thumbnail_settings_saved": "Configuración de miniaturas guardada",
  "admin_top_articles_views": "Artículos principales por vistas",
  "admin_total_articles": "Artículos Totales",
  "admin_total_users": "Usuarios Totales",
  "admin_total_views": "Vistas Totales",
  "admin_ugc_review": "Revisión de Contenido Generado por el Usuario",
  "admin_username": "Nombre de usuario",
  "admin_users_title": "Usuarios",
  "admin_version_history": "Historial de Versiones",
  "admin_view_health_report": "Ver informe de salud completo",
  "admin_write_new_article": "Escribir Nuevo Artículo",
  "adsense_client_id": "ID de Cliente de AdSense",
  "adsense_enable_disable": "Habilitar/deshabilitar toda la publicación automatizada de anuncios",
  "adsense_global_toggle": "Selector Global de AdSense",
  "adsense_script_code": "Código de Script de AdSense",
  "adsense_settings": "Configuración de AdSense y Posiciones de Anuncios",
  "advertise_contact_sales": "Contactar Ventas",
  "advertise_get_started": "Comenzar",
  "advertise_reach_audience": "Alcanza a nuestra audiencia",
  "advertise_title": "Anúnciate con Nosotros",
  "advertiser": "Anunciante",
  "advertiser_analytics": "Analíticas del Anunciante",
  "advertiser_email": "Correo del anunciante",
  "advertising": "Publicidad",
  "advertising_cookies": "Cookies de publicidad",
  "affiliate_title": "Programa de Afiliados",
  "ago": "hace",
  "ai_image_prompt": "Indicación de Imagen de IA",
  "all": "Todo",
  "all_categories": "Todas las Categorías",
  "all_jobs": "Todos los empleos",
  "all_rights": "Todos los derechos reservados",
  "all_status": "Todos los Estados",
  "all_types": "Todos los Tipos",
  "alpha": "Alfa",
  "alreadyHaveAccount": "¿Ya tienes una cuenta?",
  "already_have_account": "Ya tienes cuenta?",
  "analytics": "Analítica",
  "analytics_cookies": "Cookies analíticas",
  "api_key": "Clave API",
  "api_secret": "Secreto API",
  "applications": "Solicitudes",
  "apply": "Aplicar",
  "apply_now": "Aplicar ahora",
  "approve": "Aprobar",
  "approved": "Aprobado",
  "archive": "Archivar",
  "archived": "Archivado",
  "article_content": "Contenido del Artículo",
  "article_title": "Título del Artículo...",
  "article_views": "Vistas",
  "author": "Autor",
  "auto_posting": "Auto-publicación e integraciones sociales",
  "auto_share_articles": "Compartir automáticamente artículos publicados en plataformas conectadas",
  "avg_ctr": "CTR Promedio",
  "back": "Atras",
  "basic": "Básico",
  "be_respectful": "Sea respetuoso y civilizado con otros usuarios y temáticas de los artículos",
  "beta": "Beta",
  "book_ad": "Reservar Anuncio",
  "booking_details": "Detalles de Reserva",
  "breaking": "ULTIMA HORA",
  "bug_description": "Descripción del error",
  "business": "Negocios",
  "business_account_id": "ID de cuenta de negocio",
  "buyer": "Comprador",
  "campaign_details": "Detalles de la Campaña",
  "campaigns": "Campanas",
  "cancel": "Cancelar",
  "caption": "Subtítulo",
  "categories": "Categorias",
  "category": "Categoría",
  "category_distribution": "Distribución por Categoría",
  "category_push_subscribers": "Suscriptores de notificaciones push de categoría",
  "chatbot_placeholder": "Escribe un mensaje...",
  "chatbot_send": "Enviar",
  "chatbot_title": "Asistente de Chat",
  "choose_plan": "Elige tu plan",
  "city": "Ciudad",
  "classifieds": "Clasificados",
  "classifieds_title": "Anuncios clasificados",
  "clear": "Limpiar",
  "click_rate": "Tasa de clics",
  "click_url": "URL de Clic (destino)",
  "clicks": "Clics",
  "client_id": "ID de cliente",
  "client_secret": "Secreto de cliente",
  "close": "Cerrar",
  "code": "Código",
  "commenting_rules": "Normas de Comentarios",
  "comments": "Comentarios",
  "companies": "Empresas",
  "company": "Empresa",
  "compose_social_post": "Redactar publicación social",
  "configure": "Configurar",
  "configure_position": "Configurar cada posición con una imagen de banner personalizada o código de anuncio",
  "confirm": "Confirmar",
  "confirm_delete": "¿Está seguro de que desea eliminar?",
  "confirm_password": "Confirmar contrasena",
  "congratulations": "Felicidades",
  "contact": "Contacto",
  "contact_title": "Contacto",
  "contact_us": "Contáctenos",
  "content": "Contenido",
  "cookies": "Cookies",
  "cookies_title": "Política de cookies",
  "copy": "Copiar",
  "copyright": "Derechos de autor",
  "copyright_notice": "Derechos de autor",
  "count": "Contar",
  "country": "País",
  "cpm": "CPM",
  "create": "Crear",
  "create_first_ad": "Crear tu primer anuncio",
  "crypto_change_24h": "Cambio 24h",
  "crypto_market_cap": "Capitalización de Mercado",
  "crypto_price": "Precio",
  "crypto_widget_title": "Crypto",
  "ctr": "CTR",
  "culture": "Cultura",
  "current_plan": "Plan actual",
  "custom_ad_code": "Código de anuncio personalizado",
  "custom_banner_url": "URL de banner personalizado",
  "custom_range": "Rango personalizado",
  "daily_budget": "Presupuesto Diario",
  "daily_performance": "Desempeño Diario",
  "dark_mode": "Modo oscuro",
  "data_viz_title": "Visualización de Datos",
  "date": "Fecha",
  "dating_add_video": "Añade un video corto para que posibles coincidencias puedan conocerte mejor",
  "dating_block": "Bloquear",
  "dating_boosts": "Impulsos",
  "dating_city": "Ciudad",
  "dating_next": "Siguiente",
  "dating_personality_quiz": "Cuestionario de personalidad",
  "dating_quiz_completed": "Cuestionario de personalidad completado",
  "dating_users": "Usuarios",
  "dating_verify_identity": "Verifique que usted es una persona real",
  "dating_voice_message": "Mensaje de voz",
  "days": "días",
  "delete": "Eliminar",
  "delete_failed": "Eliminación fallida.",
  "deleted_successfully": "Eliminado exitosamente",
  "deprecated": "Obsoleto",
  "describe_thumbnail": "Describe la imagen en miniatura para generar...",
  "description": "Descripción",
  "deselect_all": "Deseleccionar todo",
  "desktop": "Escritorio",
  "details": "Detalles",
  "dimensions": "Dimensiones",
  "disabled": "Deshabilitado",
  "dismiss": "Descartar",
  "documentation": "Documentación",
  "doktor_add_document": "Añadir Documento",
  "doktor_biography": "Biografía",
  "doktor_birth_date": "Fecha de Nacimiento",
  "doktor_chat": "Chat",
  "doktor_control_date": "Fecha de Control",
  "doktor_date": "Fecha",
  "doktor_diagnosis": "Diagnóstico",
  "doktor_enter_name_specialization": "Ingresa nombre y al menos una especialización",
  "doktor_enter_patient_name": "Ingresa el nombre del paciente",
  "doktor_license_number": "Número de Licencia",
  "doktor_panel": "Panel del Doctor",
  "doktor_patient_name": "Nombre del Paciente",
  "doktor_text_min_chars": "El texto debe tener al menos 50 caracteres",
  "doktor_waiting_room": "Sala de Espera",
  "dont_have_account": "No tienes cuenta?",
  "download": "Descargar",
  "draft": "Borrador",
  "duplicate": "Duplicar",
  "duration_days": "Duración (días)",
  "economy": "Economía",
  "edit": "Editar",
  "electronics": "Electrónica",
  "email": "Correo Electrónico",
  "email_address": "Dirección de correo electrónico",
  "email_campaigns": "Campañas de correo electrónico",
  "email_clicks": "Clics en email",
  "email_content": "Contenido del correo electrónico...",
  "email_opens": "Aperturas de email",
  "email_placeholder": "Su correo electronico",
  "email_subject": "Asunto del correo electrónico",
  "employer": "Empleador",
  "enabled": "Habilitado",
  "end_date": "Fecha de Fin",
  "enter_advertiser_email": "Ingresa tu correo de anunciante...",
  "enter_email_to_view": "Ingresa tu correo de anunciante arriba para ver el rendimiento de tu campaña",
  "entertainment": "Entretenimiento",
  "error": "Error",
  "error_deleting": "Error al eliminar",
  "error_generating_digest": "Error generando resumen",
  "error_loading": "Error al cargar",
  "error_saving": "Error al guardar",
  "error_saving_settings": "Error al guardar",
  "error_sending": "Error al enviar",
  "error_uploading": "Error al subir",
  "error_uploading_photo": "Error al subir la foto",
  "events_calendar": "Calendario de eventos",
  "excerpt_summary": "Extracto / Resumen",
  "experimental": "Experimental",
  "export": "Exportar",
  "export_data": "Exportar Datos",
  "facebook": "Facebook",
  "facebook_login_unavailable": "Inicio de sesión de Facebook no disponible",
  "failed_post_comment": "No se pudo publicar el comentario.",
  "feature_flags": "Flags de Funcionalidades",
  "feature_job": "Puesto destacado",
  "featured": "Destacado",
  "featured_article": "Artículo destacado",
  "featured_duration": "Duración Destacada",
  "featured_image": "Imagen Destacada",
  "featured_jobs": "Empleos destacados",
  "feedback": "Retroalimentación",
  "filter": "Filtrar",
  "filter_terms_saved": "¡Términos del filtro guardados!",
  "find_jobs": "Buscar empleos",
  "first": "Primera",
  "first_process_publish": "Primero procesa y publica el artículo",
  "footer_ai": "Este portal utiliza asistencia de IA",
  "footer_ai_notice": "Algunos contenidos creados con asistencia de IA - reportar problemas",
  "footer_cat_business": "Negocios",
  "footer_cat_culture": "Cultura",
  "footer_cat_health": "Salud",
  "footer_cat_news": "Noticias",
  "footer_cat_politics": "Política",
  "footer_cat_sports": "Deportes",
  "footer_cat_technology": "Tecnología",
  "footer_categories": "Categorías",
  "footer_copyright": "2026 Liber Nostra d.o.o. Todos los derechos reservados.",
  "footer_description": "Croatia Times es tu fuente confiable de noticias de última hora, análisis a fondo y historias atractivas de Croacia y más allá.",
  "footer_developed_by": "Desarrollado y mantenido con amor por",
  "footer_email_placeholder": "Tu dirección de correo electrónico",
  "footer_here": "aquí",
  "footer_hosted_by": "Alojado por",
  "footer_link_about": "Sobre Nosotros",
  "footer_link_advertise": "Publicidad",
  "footer_link_contact": "Contacto",
  "footer_link_cookies": "Cookies",
  "footer_link_imprint": "Imprint",
  "footer_link_privacy": "Política de Privacidad",
  "footer_link_submit_news": "Enviar Noticias",
  "footer_newsletter_text": "Suscríbete a nuestro boletín",
  "footer_quick_links": "Enlaces Rápidos",
  "footer_stay_informed": "Mantente Informado",
  "footer_subscribe": "Suscribirse",
  "for_you_personalized": "Contenido personalizado basado en tus intereses",
  "for_you_title": "Para Ti",
  "forgot_password": "Olvidaste tu contrasena?",
  "free": "Gratis",
  "free_plan": "Gratis",
  "from": "Desde",
  "full_time": "Tiempo completo",
  "general": "General",
  "goodbye": "Adiós",
  "hashtags": "Hashtags",
  "hashtags_placeholder": "#news #croatia...",
  "header_auto_schedule_active": "Programación automática activa",
  "header_forecast": "Pronóstico",
  "header_humidity": "Humedad",
  "header_live": "EN VIVO",
  "header_portals_label": "Portales",
  "header_weather_humidity": "Humedad",
  "header_weather_wind": "Viento",
  "header_wind": "Viento",
  "health": "Salud",
  "hello": "Hola",
  "help": "Ayuda",
  "home": "Inicio",
  "home_podcast_title": "Resumen Semanal de Tecnología: IA en Startups Croatas",
  "home_video_title": "Dentro de Zagreb: Documental de Arte Callejero",
  "hours": "horas",
  "import": "Importar",
  "impressions": "Impresiones",
  "imprint": "Aviso legal",
  "imprint_title": "Imprimir",
  "inactive": "Inactivo",
  "info": "Información",
  "instagram": "Instagram",
  "invalid_code": "Código inválido. Intenta de nuevo.",
  "items_selected": "artículos seleccionados",
  "job_categories": "Categorias de empleo",
  "job_postings": "Ofertas de Trabajo",
  "job_seeker": "Buscador de empleo",
  "jobs": "Empleos",
  "just_now": "Justo ahora",
  "language": "Idioma",
  "last": "Última",
  "latest_news": "Últimas Noticias",
  "legal": "Legal",
  "lifestyle": "Estilo de vida",
  "lifetime": "De por vida",
  "light_mode": "Modo claro",
  "linked_email_campaign": "Vinculado a campaña de correo electrónico",
  "linkedin": "LinkedIn",
  "live_stream": "Transmisión en vivo",
  "load_more": "Cargar más",
  "loading": "Cargando...",
  "local": "Local",
  "location": "Ubicacion",
  "login": "Iniciar sesion",
  "logout": "Cerrar sesion",
  "loyalty_available_points": "Puntos disponibles",
  "loyalty_available_rewards": "Recompensas disponibles",
  "loyalty_badges": "Insignias",
  "loyalty_consecutive_days": "Días consecutivos",
  "loyalty_error": "Error",
  "loyalty_leaderboard": "Tabla de clasificación",
  "loyalty_leaderboard_empty": "La tabla de clasificación está vacía",
  "loyalty_rewards": "Recompensas",
  "loyalty_used_rewards": "Recompensas utilizadas",
  "majstor_categories": "Categorías",
  "majstor_city": "Ciudad",
  "majstor_company_name": "Nombre de la empresa *",
  "majstor_flexible": "Flexible",
  "majstor_max_budget": "Presupuesto máximo (EUR)",
  "majstor_min_budget": "Presupuesto mínimo (EUR)",
  "majstor_my_requests": "Mis solicitudes",
  "majstor_request_title": "Título de la solicitud *",
  "majstor_service_categories": "Categorías de servicio",
  "majstor_urgent": "Urgente",
  "manage": "Gestionar",
  "manage_bookings": "Gestionar reservas de anunciantes",
  "mark_as_read": "Marcar como leído",
  "marketing_dashboard": "Panel de Marketing",
  "marketing_live_metrics": "Métricas de rendimiento en vivo para Croatia Times",
  "marketing_published_articles": "Artículos Publicados",
  "marketing_registered_users": "Usuarios Registrados",
  "marketing_today_views": "Vistas de Hoy",
  "marketing_total_views": "Total de Vistas de Página",
  "minutes": "minutos",
  "missing_translations": "Traducciones faltantes",
  "mobile": "Teléfono Móvil",
  "more": "Más",
  "most_popular": "Mas popular",
  "most_read": "Más Leído",
  "move": "Mover",
  "must_be_logged_in_purchase": "Debes estar registrado para comprar un artículo",
  "myProfile": "Mi Perfil",
  "my_applications": "Mis solicitudes",
  "name": "Nombre",
  "new": "Nuevo",
  "new_article": "Nuevo Artículo",
  "new_campaign": "Nueva campaña",
  "new_notification": "Nueva notificación",
  "new_push_notification": "Nueva notificación push",
  "new_verification_sent": "Se ha enviado un nuevo código de verificación a tu correo electrónico.",
  "news": "Noticias",
  "newsletter": "Boletin",
  "newsletter_desc": "Suscribase a las ultimas noticias",
  "newsletter_only_subscribers": "Solo suscriptores",
  "newsletter_subscribers": "Suscriptores del boletín",
  "next": "Siguiente",
  "no": "No",
  "noAccount": "¿No tienes una cuenta?",
  "no_articles": "No se encontraron artículos",
  "no_bookings": "No se encontraron reservas",
  "no_campaigns": "No hay campañas",
  "no_data": "No hay datos disponibles",
  "no_items": "No se encontraron elementos",
  "no_linked_campaign": "No hay campaña vinculada",
  "no_notifications": "No hay notificaciones",
  "no_results": "Sin resultados",
  "no_scheduled_posts": "No hay publicaciones programadas aún",
  "no_sent_notifications": "No hay notificaciones enviadas",
  "none": "Ninguno",
  "note": "Nota",
  "notification_body": "Cuerpo de la notificación",
  "notification_title": "Título de la notificación",
  "notifications": "Notificaciones",
  "of": "de",
  "off": "Apagado",
  "offline": "Desconectado",
  "on": "Encendido",
  "one_time": "unico pago",
  "online": "En línea",
  "open_rate": "Tasa de apertura",
  "optional": "Opcional",
  "options": "Opciones",
  "orContinueWith": "O continuar con",
  "or_continue_with": "O continuar con",
  "order": "Pedido",
  "other": "Otros",
  "page": "Página",
  "part_time": "Medio tiempo",
  "password": "Contrasena",
  "paste": "Pegar",
  "pause": "Pausar",
  "payment_error": "Error de pago",
  "payment_processing": "Procesando pago...",
  "payment_success": "Pago exitoso!",
  "payment_thank_you": "¡Gracias por tu compra!",
  "pending": "Pendiente",
  "pending_approval": "Pendiente de Aprobación",
  "per_month": "/mes",
  "per_page": "por página",
  "percentage": "Porcentaje",
  "performance": "Desempeño",
  "phone": "Teléfono",
  "platforms": "Plataformas",
  "politics": "Politica",
  "poll_results": "Resultados",
  "poll_total_votes": "Total de Votos",
  "poll_vote": "Votar",
  "popular": "Popular",
  "post_comment": "Publicar comentario",
  "post_error": "Error en la publicación",
  "post_job": "Publicar empleo",
  "post_now": "Publicar ahora",
  "powered_by": "Desarrollado por",
  "premium": "Premium",
  "preview": "Vista previa",
  "previous": "Anterior",
  "price": "Precio",
  "privacy": "Privacidad",
  "privacy_title": "Política de privacidad",
  "proceed_to_payment": "Proceder al Pago",
  "profile": "Perfil",
  "profile_admin_access": "Acceso Rápido de Admin",
  "profile_analytics": "Analíticas",
  "profile_articles": "Artículos",
  "profile_dashboard": "Panel",
  "profile_edit": "Editar Perfil",
  "profile_verified": "¡Perfil verificado!",
  "promo_success": "¡Código promocional aplicado con éxito!",
  "promote_job": "Promocionar Puesto",
  "publish": "Publicar",
  "published": "Publicado",
  "published_date": "Publicado",
  "push_notifications": "Notificaciones push",
  "read": "Leído",
  "read_more": "Leer mas",
  "real_estate": "Bienes Raíces",
  "recent": "Recientes",
  "recipes_add_first": "Añade tu primera receta",
  "recipes_browse_all": "Explorar todas las recetas",
  "recipes_category": "Categoría",
  "recipes_cook_time": "Tiempo de Cocción",
  "recipes_easy": "Fácil",
  "recipes_featured": "Recetas Destacadas",
  "recipes_filters": "Filtros",
  "recipes_ingredient": "Ingrediente",
  "recipes_ingredients": "Ingredientes",
  "recipes_instructions": "Instrucciones",
  "recipes_latest": "Últimas Recetas",
  "recipes_most_popular": "Recetas Más Populares",
  "recipes_prep_time": "Tiempo de Preparación",
  "recipes_search": "Buscar recetas...",
  "recipes_servings": "Porciones",
  "recipes_title": "Recetas",
  "recommended": "Recomendado",
  "refresh": "Actualizar",
  "region": "Región",
  "register": "Registrarse",
  "reject": "Rechazar",
  "rejected": "Rechazado",
  "related_articles": "Artículos Relacionados",
  "remote": "Remoto",
  "remove": "Eliminar",
  "report": "Informe",
  "reports": "Informes",
  "reposting_rules_title": "Reglas de republicación",
  "required": "Requerido",
  "reset": "Restablecer",
  "restore": "Restaurar",
  "results": "Resultados",
  "resume": "Reanudar",
  "revision_restored": "¡Revisión restaurada!",
  "salary": "Salario",
  "salary_max": "Salario Máximo",
  "salary_min": "Salario Mínimo",
  "save": "Guardar",
  "saved_jobs": "Empleos guardados",
  "saved_successfully": "Guardado exitosamente",
  "schedule": "Horario",
  "scheduled": "Programado",
  "science": "Ciencia",
  "search": "Buscar...",
  "search_articles": "Buscar artículos...",
  "search_placeholder": "Buscar...",
  "search_results_for": "Resultados de búsqueda para",
  "seconds": "segundos",
  "see_all": "Ver todo",
  "select": "Seleccionar",
  "select_all": "Seleccionar todo",
  "select_format": "Seleccionar Formato",
  "seller": "Vendedor",
  "send_campaign": "Enviar campaña",
  "sent": "Enviado",
  "sent_campaigns": "Campañas enviadas",
  "services": "Servicios",
  "settings": "Configuraciones",
  "share": "Compartir",
  "showing": "Mostrando",
  "signIn": "Iniciar Sesión",
  "signOut": "Cerrar Sesión",
  "site_name": "Croatia Times",
  "site_subtitle": "Croacia Hoy",
  "six_digit_code": "Código de 6 dígitos",
  "social_media": "Medios sociales",
  "social_scheduler": "Programador social",
  "sort": "Ordenar",
  "sponsored_marketplace_title": "Mercado Patrocinado",
  "sports": "Deportes",
  "stable": "Estable",
  "start": "Iniciar",
  "start_date": "Fecha de Inicio",
  "static_about_contact": "Para consultas editoriales, publicidad o información general, visita nuestra",
  "static_about_contact_page": "página de contacto",
  "static_about_contact_title": "Contacto",
  "static_about_lead": "Croatia Times es un portal de noticias independiente que te trae las últimas noticias, análisis, comentarios e historias de Croacia y la región. Somos parte de la familia de medios e-mina.eu, con el mismo equipo y los mismos valores.",
  "static_about_mission": "Estamos dedicados a ofrecer un periodismo preciso, oportuno y de calidad que sirva al interés público. Nuestro equipo editorial está compuesto por periodistas experimentados con un profundo conocimiento de los asuntos croatas y regionales.",
  "static_about_mission_title": "Nuestra Misión",
  "static_about_publisher": "Liber Nostra d.o.o. es el editor de Croatia Times y e-mina.eu. La empresa se especializa en medios digitales y portales de noticias enfocados en el mercado croata.",
  "static_about_publisher_title": "Editor",
  "static_about_standards": "Croatia Times se adhiere a los más altos estándares periodísticos. Verificamos los hechos en nuestros informes, etiquetamos claramente los comentarios y análisis, y corregimos los errores de manera rápida y transparente.",
  "static_about_standards_title": "Normas Editoriales",
  "static_about_team": "Detrás de Croatia Times hay un equipo de profesionales experimentados de los medios, periodistas, editores y expertos técnicos que trabajan en el desarrollo de la plataforma y la calidad del contenido. Nuestro equipo es el mismo detrás del exitoso portal e-mina.eu - Agencia Internacional de Noticias.",
  "static_about_team_title": "Equipo",
  "static_about_title": "Sobre Nosotros - Croatia Times",
  "static_bug_description": "Descripción del Error",
  "static_bug_description_placeholder": "Describe lo que sucedió y cómo reproducir el problema...",
  "static_bug_intro": "¿Encontraste algo que no funciona correctamente? Avísanos y lo solucionaremos rápidamente.",
  "static_bug_page_url": "URL de la página (donde ocurrió el error)",
  "static_bug_screenshot": "Captura de pantalla (opcional)",
  "static_bug_submit": "Enviar Reporte de Error",
  "static_bug_submitting": "Enviando...",
  "static_bug_thanks": "¡Gracias por tu reporte! Investigaremos y solucionaremos el problema.",
  "static_bug_title": "Reportar un Error",
  "static_commenting_intro": "Damos la bienvenida a discusiones constructivas. Para mantener nuestra sección de comentarios positiva y productiva, sigue estas reglas:",
  "static_commenting_login": "Para comentar, debes estar registrado e iniciar sesión en Croatia Times.",
  "static_commenting_rule_1": "Sé respetuoso y cortés con otros usuarios y los sujetos de los artículos",
  "static_commenting_rule_2": "No se permite discurso de odio, racismo, sexismo o discriminación de ningún tipo",
  "static_commenting_rule_3": "No se permite spam, publicidad o contenido promocional",
  "static_commenting_rule_4": "No se permite desinformación o difusión de afirmaciones no verificadas",
  "static_commenting_rule_5": "No se permiten ataques personales o acoso",
  "static_commenting_rule_6": "Mantente en el tema y contribuye a la conversación",
  "static_commenting_rule_7": "No compartas información personal o confidencial sobre terceros",
  "static_commenting_title": "Reglas de Comentarios",
  "static_commenting_violation": "Los comentarios que violen estas reglas pueden ser eliminados sin previo aviso. Los infractores reincidentes pueden ser baneados permanentemente.",
  "static_contact_email": "Correo electrónico",
  "static_contact_message": "Mensaje",
  "static_contact_message_placeholder": "Tu mensaje...",
  "static_contact_name": "Nombre",
  "static_contact_name_placeholder": "Tu nombre",
  "static_contact_send": "Enviar Mensaje",
  "static_contact_sending": "Enviando...",
  "static_contact_sent_desc": "Nos pondremos en contacto contigo dentro de 24 horas.",
  "static_contact_sent_title": "¡Mensaje Enviado!",
  "static_contact_subject": "Asunto",
  "static_contact_subject_placeholder": "¿En qué podemos ayudarte?",
  "static_contact_title": "Contáctanos",
  "static_cookies_advertising_text": "Podemos usar cookies de Google AdSense para ofrecer anuncios relevantes.",
  "static_cookies_advertising_title": "Cookies de Publicidad",
  "static_cookies_analytics_text": "Google Analytics nos ayuda a comprender cómo los visitantes usan nuestro sitio. Los datos se anonimizan siempre que sea posible.",
  "static_cookies_analytics_title": "Cookies de Análisis",
  "static_cookies_managing_text": "Puedes controlar las cookies a través de la configuración de tu navegador. Desactivar las cookies necesarias puede afectar la funcionalidad del sitio.",
  "static_cookies_managing_title": "Gestión de Cookies",
  "static_cookies_necessary_text": "Estas son necesarias para que el sitio funcione (sesiones de inicio de sesión, preferencias de tema). No se pueden desactivar.",
  "static_cookies_necessary_title": "Cookies Necesarias",
  "static_cookies_title": "Política de Cookies",
  "static_cookies_types_title": "Tipos de Cookies que Usamos",
  "static_cookies_what_text": "Las cookies son pequeños archivos de texto que se colocan en tu dispositivo cuando visitas un sitio web. Ayudan al sitio a recordar tus preferencias y comprender cómo lo utilizas.",
  "static_cookies_what_title": "Qué Son las Cookies",
  "static_imprint_ads_email": "Correo electrónico (publicidad):",
  "static_imprint_ai_notice": "Parte del contenido es generado usando tecnología de IA. Reporta errores o contenido inapropiado a",
  "static_imprint_contact": "Contacto",
  "static_imprint_copyright": "Derechos de Autor",
  "static_imprint_copyright_text": "Todo el contenido publicado en Croatia Times está protegido por derechos de autor. Liber Nostra d.o.o. retiene todos los derechos sobre los textos, imágenes y contenido multimedia publicado en este sitio. Información detallada sobre las reglas de reposteo de contenido está disponible en la",
  "static_imprint_ct_desc": "Portal de noticias Croatia Times",
  "static_imprint_disclaimer": "Descargo de responsabilidad",
  "static_imprint_disclaimer_text": "A pesar de un cuidadoso control del contenido, no asumimos responsabilidad por enlaces externos. Sus operadores son los únicos responsables de su contenido.",
  "static_imprint_editorial_email": "Correo electrónico (editorial):",
  "static_imprint_emina_desc": "Agencia Internacional de Noticias",
  "static_imprint_general_email": "Correo electrónico (consultas generales):",
  "static_imprint_last_updated": "Última actualización: febrero de 2026",
  "static_imprint_or_via": "o a través de nuestro",
  "static_imprint_publisher": "Editor",
  "static_imprint_registered": "Registrado en la República de Croacia",
  "static_imprint_reposting_page": "página de Reglas de Reposteo",
  "static_imprint_responsible": "Responsable de Contenido",
  "static_imprint_responsible_text": "Equipo editorial de Croatia Times / Liber Nostra d.o.o.",
  "static_imprint_title": "Imprint",
  "static_imprint_websites": "Sitios web",
  "static_privacy_controller": "Responsable del Tratamiento de Datos: Liber Nostra d.o.o.",
  "static_privacy_cookies_text": "Utilizamos cookies para funcionalidad y análisis. Consulta nuestra Política de Cookies para más detalles.",
  "static_privacy_cookies_title": "Cookies",
  "static_privacy_data_text": "Recopilamos datos que proporcionas directamente (nombre, correo electrónico al registrarte), datos de uso (páginas visitadas, artículos leídos) y datos técnicos (dirección IP, tipo de navegador).",
  "static_privacy_data_title": "Datos que Recopilamos",
  "static_privacy_last_updated": "Última actualización: enero 2026",
  "static_privacy_lead": "Croatia Times respeta tu privacidad y se compromete a proteger tus datos personales.",
  "static_privacy_retention_text": "Conservamos tus datos mientras tu cuenta esté activa, o según sea necesario por motivos legales.",
  "static_privacy_retention_title": "Retención de Datos",
  "static_privacy_rights_text": "Tienes derecho a acceder, corregir o eliminar tus datos personales. Contáctanos en",
  "static_privacy_rights_title": "Tus Derechos",
  "static_privacy_title": "Política de Privacidad",
  "static_privacy_usage_text": "Utilizamos tus datos para ofrecer nuestro servicio de noticias, personalizar tu experiencia, enviar boletines informativos (con tu consentimiento) y mejorar nuestra plataforma.",
  "static_privacy_usage_title": "Cómo Usamos Tus Datos",
  "static_reposting_copyright_text": "Todo el contenido publicado en Croatia Times está protegido por derechos de autor. Liber Nostra d.o.o. retiene todos los derechos sobre el texto, imágenes y multimedia publicados en este sitio web.",
  "static_reposting_copyright_title": "Derechos de Autor",
  "static_reposting_permission_text": "Para obtener permiso para reimprimir contenido, contáctanos en",
  "static_reposting_permission_title": "Solicitudes de Permiso",
  "static_reposting_permitted_text": "Puede compartir enlaces a nuestros artículos en redes sociales y otras plataformas. Se pueden usar citas cortas (hasta 2 párrafos) con una atribución clara y un enlace de regreso al artículo original.",
  "static_reposting_permitted_title": "Uso Permitido",
  "static_reposting_prohibited_text": "Se prohíbe la reimpresión completa de artículos sin permiso por escrito. Las imágenes no pueden ser reproducidas sin permiso. La extracción automatizada de contenido está estrictamente prohibida.",
  "static_reposting_prohibited_title": "Uso Prohibido",
  "static_reposting_title": "Reglas de Re-publicación",
  "static_submit_news_details": "Detalles de la Historia",
  "static_submit_news_details_placeholder": "Describe las noticias...",
  "static_submit_news_file_limit_error": "El archivo excede el límite de",
  "static_submit_news_headline": "Titular de las Noticias",
  "static_submit_news_intro": "¿Tienes noticias? Envíalas aquí y nuestro equipo editorial las revisará.",
  "static_submit_news_limit": "Aceptamos fotos y videos de hasta",
  "static_submit_news_photos": "Fotos / Video (hasta",
  "static_submit_news_send": "Enviar Noticias",
  "static_submit_news_sending": "Enviando...",
  "static_submit_news_source": "Fuente / Referencia (opcional)",
  "static_submit_news_source_placeholder": "URL o referencia",
  "static_submit_news_thanks": "¡Gracias por tu envío! Nuestro equipo lo revisará en breve.",
  "static_submit_news_title": "Envía tus Noticias",
  "static_submit_news_your_name": "Tu Nombre",
  "status": "Estado",
  "stop": "Detener",
  "submit": "Enviar",
  "submitNews": "Enviar Noticias",
  "submit_bug_title": "Enviar informe de errores",
  "submit_news": "Enviar noticia",
  "submit_news_title": "Enviar noticias",
  "subscribe": "Suscribirse",
  "subscription": "Suscripcion",
  "subscription_title": "Planes de Suscripción",
  "success": "Exito",
  "support": "Soporte",
  "tablet": "Tableta",
  "tags": "Etiquetas",
  "target_impressions": "Impresiones Objetivo",
  "technology": "Tecnologia",
  "template": "Plantilla",
  "templates": "Plantillas",
  "terms": "Términos",
  "thank_you": "Gracias",
  "this_month": "Este mes",
  "this_week": "Esta semana",
  "this_year": "Este año",
  "tip": "Consejo",
  "title": "Título",
  "to": "Hasta",
  "today": "Hoy",
  "total": "Total",
  "translate_all": "Traducir todo",
  "translation_status": "Estado de la traducción",
  "translations": "Traducciones",
  "travel": "Viaje",
  "trending": "Tendencias",
  "try_again": "Intentar de nuevo",
  "twitter": "Twitter",
  "two_factor_auth": "Autenticación de Dos Factores",
  "type": "Tipo",
  "ugc_submit": "Enviar Contenido",
  "ugc_title": "Portal de Periodismo Ciudadano",
  "unique_clicks": "Clics únicos",
  "unique_opens": "Aperturas únicas",
  "unknown": "Desconocido",
  "unpublish": "Despublicar",
  "unread": "No leído",
  "update": "Actualizar",
  "updated_successfully": "Actualizado exitosamente",
  "upgrade": "Mejorar",
  "upload": "Subir",
  "users": "Usuarios",
  "vehicles": "Vehículos",
  "verification_code_sent": "¡Código de verificación enviado a tu correo electrónico!",
  "version": "Versión",
  "vibeposao": "Times Posao",
  "view": "Ver",
  "view_all": "Ver todo",
  "views": "Vistas",
  "warning": "Advertencia",
  "welcome": "Bienvenido",
  "wish_roles": "Roles deseados",
  "working_hours_saved": "¡Horario laboral guardado!",
  "world": "Mundo",
  "write_new_article": "Escribir Nuevo Artículo",
  "yes": "Sí",
  "yesterday": "Ayer",
  "your_bookings": "Tus Reservas",
  "youtube": "YouTube"
}
